import { ShieldCheck } from "lucide-react";

/**
 * Bandeau bleu "Assurance décennale April" — visible en haut de toutes les pages du site.
 * Renforce la confiance et le SEO local.
 */
const AprilBanner = () => (
    <div className="bg-[#0055A4] text-white border-b border-[#0055A4]" data-testid="april-banner">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
            <ShieldCheck className="h-5 w-5 text-white" strokeWidth={2.5} />
            <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.15em]">
                Assurance décennale <span className="text-white font-bold">April</span>
            </span>
            <span className="hidden sm:inline text-white/60">·</span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-white/90 font-medium">
                Toutes nos poses garanties
            </span>
        </div>
    </div>
);

export default AprilBanner;
